import { mapMutations } from 'vuex'

export default {
  props: {
    reserveCount: {
      type: Number|String,
      default: '',
    },
    video: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      videoBoxVisible: false,
    }
  },
  computed: {
    stage() {
      return this.$store.getters.stage
    },
    user() {
      return this.$store.getters.user
    },
    isLogin() {
      return Object.keys(this.user).length > 0
    },
    isReserved() {
      return this.$store.getters.isReserved
    },
    isInvited() {
      return this.$route.query.inviteCode
    },
    downloadUrl() {
      return this.$store.getters.downloadUrl
    },
  },
  methods: {
    ...mapMutations(['setTipsDialog', 'setLoginDialog']),
    openReserveDialog() {
      if (this.isLogin || this.isReserved) return false
      
      this.$emit('reserve')
    },
    openLink() {
      window.open('https://tap.cn/s8pEeyJJ?channel=rep-rep_soxlkwnbfcn')
    },
    openVideoBox() {
      this.videoBoxVisible = true
    },
    download(os) {
      switch (os) {
        case 'ios':
          if (this.isInvited && !this.isLogin) {
            this.setLoginDialog({ visible: true })
            break
          }
          window.location.href = 'https://apps.apple.com/cn/app/%E4%BB%8E%E5%89%8D%E6%9C%89%E6%9D%A1%E8%A1%97/id6471931091'
          break;
        case 'android':
          if (this.isInvited && !this.isLogin) {
            this.setLoginDialog({ visible: true })
            break
          }

          if (!this.downloadUrl) {
            this.setTipsDialog({ visible: true, tips: '安卓下载地址获取失败，请刷新页面后重试' })
            break
          }
          window.open(this.downloadUrl)
          break;
        case 'taptap':
          window.open('https://tap.cn/s8pEeyJJ?channel=rep-rep_soxlkwnbfcn')
          break;
      }
    },
    openDownloadLink(type) {
      let url = ''
      switch (type) {
        case 'thunder': // 雷电
          url = 'https://lddl01.ldmnq.com/downloader/ldplayerinst9.exe?n=LDplayer9_com.yuwan.cqytj.gw_403509_ld.exe'
          break
        case 'mumu': // mumu
          url = 'https://a11.gdl.netease.com/MuMuInstaller_3.1.8.0_yx-cqytj_zh-Hans_1721650361.exe'
          break
        case 'taptap': // TapTap
          url = 'https://www.taptap.cn/app/208783'
          break
        case 'hykb': // 好游快爆
          url = 'https://www.3839.com/a/131247.htm'
          break
      }

      if (url) {
        setTimeout(function () {
          window.open(url, '_blank')
        })
      }
    },
  }
}